// extracted by mini-css-extract-plugin
export default {"header":"SavedCardsCard_header__voNMt","navigateButton":"SavedCardsCard_navigateButton__UDlIK","card":"SavedCardsCard_card__zRW6M"};